module.exports = __webpack_public_path__ + "static/media/back-arrow.5312342a.svg";